<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- 		 	 -->
<!-- LOCK TO TOP -->
<!-- 			 -->
<div class="lock-to-top-off" style="background-color: #ffffff">
	<!-- 		 -->
	<!-- Buttons -->
	<!-- 		 -->
	<div class="button-body">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onUpdate()" [disabled]="isBusy == true">Update</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onExport()" [disabled]="isBusy == true">Export</button>
		<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo == true ? 'block' : 'none'">
		<label>&#9900; Total ScanStations: {{ lstStation.length }}&nbsp;&nbsp;&nbsp;&nbsp;(no filters)</label><br />
		<label>&#9900; Total ScanStations commissioned: {{ lstStation.length - TotalDeCommissionCount }}</label
		><br />
		<label>&#9900; Total ScanStations decommissioned: {{ TotalDeCommissionCount }}</label
		><br />
		<label>&#9900; Use ctl to add a column to the sort selection</label><br />
	</div>
</div>

<!-- 					  -->
<!-- Display Stations 	  -->
<!-- 					  -->
<div class="station-table-main-body">
	<!-- Note: resizableColumns breaks the multiline ability -->
	<p-table
		#mydt
		[value]="lstStation"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="lstStationChecked"
		[rowHover]="true"
		dataKey="ScanStationID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50, 100]"
	>
		<ng-template pTemplate="header">
			<!-- 				-->
			<!-- Filter Section -->
			<!-- 				-->
			<tr>
				<th>
					<div class="station-filter-row-group">
						<!-- 				   -->
						<!-- Display When Busy -->
						<!-- 				   -->
						<div [style.display]="isBusy == true ? 'block' : 'none'" style="width: 20px">
							<img class="busy-img" src="assets/images/loading.gif" />
						</div>
						<div [style.display]="isBusy == false ? 'block' : 'none'" style="width: 20px"></div>
					</div>
				</th>

				<th>
					<p-columnFilter type="text" field="ScanStation" matchMode="startsWith" [showMenu]="true"></p-columnFilter>
				</th>

				<th>
					<p-columnFilter field="FacilityName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterFacilityName
								[ngModel]="value"
								[options]="lstFacilitys"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter field="SchoolName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSchoolName
								[ngModel]="value"
								[options]="lstSchools"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter field="isDecommissionedDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterisDecommissionedDesc
								[ngModel]="value"
								[options]="lstisDecommissionedDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="date" field="LastSyncDate" display="menu">
						<ng-template pTemplate="filter" let-filter="filterCallback">
							<p-calendar (onSelect)="filter($event)"></p-calendar>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!-- 			  -->
			<!-- Sort Section -->
			<!-- 			  -->
			<tr>
				<th pSortableColumn="isDecommissioned">Decommission<p-sortIcon field="isDecommissioned"></p-sortIcon></th>
				<th pSortableColumn="ScanStation">ScanStation<p-sortIcon field="ScanStation"></p-sortIcon></th>
				<th pSortableColumn="FacilityName">Facility<p-sortIcon field="FacilityName"></p-sortIcon></th>
				<th pSortableColumn="SchoolName">School<p-sortIcon field="SchoolName"></p-sortIcon></th>
				<th pSortableColumn="DecommissionedDate">Decommission Date<p-sortIcon field="DecommissionedDate"></p-sortIcon></th>
				<th pSortableColumn="LastSyncDate">Last Sync Date<p-sortIcon field="LastSyncDate"></p-sortIcon></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rStationItem>
			<tr [pSelectableRow]="rStationItem">
				<td>
					<div>
						<p-tableCheckbox [value]="rStationItem"></p-tableCheckbox>
					</div>
				</td>

				<td>
					<div class="station-table-data1">
						{{ rStationItem.ScanStation }}
					</div>
				</td>

				<td>
					<div class="station-table-data2">
						{{ rStationItem.FacilityName }}
					</div>
				</td>

				<td>
					<div class="station-table-data2">
						{{ rStationItem.SchoolName }}
					</div>
				</td>

				<td>
					<div [style.display]="rStationItem.DecommissionedDate != '0001-01-01T00:00:00' ? 'table-cell' : 'none'">
						{{ rStationItem.DecommissionedDate | date : "MMM d, y, h:mm a" }}
					</div>
				</td>

				<td>
					<div [style.display]="rStationItem.HasSyncDate == true ? 'table-cell' : 'none'">
						{{ rStationItem.LastSyncDate | date : "MMM d, y, h:mm a" }}
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!-- 						       			 -->
<!-- Display When No ScanStations configured -->
<!-- 						       			 -->
<div style="padding: 20px" [style.display]="lstStation.length < 1 && isBusy == false ? 'block' : 'none'">
	<label>No ScanStations configured...</label>
</div>
